import React from 'react'
import { BooleanInput, FormDataConsumer } from 'react-admin'
import { MappedEnrichedEvent } from 'services/api/entities/events/types/internal/event-models'
import { FormDataConsumerProps, ProductServiceName } from 'types/common'
import SupplierSelectInput from 'ui-shared/CustomInputs/SupplierSelectInput'
import KRichTextInput from 'ui-shared/WrappedInputs/KRichTextInput'

type Props = {
  source: ProductServiceName
}

const EventServiceSection: React.FC<Props> = ({ source }) => {
  return (
    <>
      <FormDataConsumer>
        {({ formData }: FormDataConsumerProps<MappedEnrichedEvent>) => {
          const service = formData.productServices?.[source]
          return (
            <>
              <SupplierSelectInput
                source={`productServices.${source}.supplier`}
              />
              <BooleanInput
                label="Trigger Supplier Email"
                source={`productServices.${source}.triggerAssignmentEmail`}
              />
              <BooleanInput
                label={
                  !!service?.supplyConfirmed
                    ? 'Supply confirmed'
                    : 'Supply not yet confirmed'
                }
                source={`productServices.${source}.supplyConfirmed`}
                disabled
              />
              {!!service?.supplier && (
                <KRichTextInput
                  source={`productServices.${source}.lastMessage`}
                  label="Last supplier message"
                />
              )}
              {!!service?.supplier && (
                <BooleanInput
                  label={
                    !!service?.lastMessageConfirmed
                      ? 'Last message confirmed'
                      : 'Last message not yet confirmed'
                  }
                  source={`productServices.${source}.lastMessageConfirmed`}
                  disabled
                />
              )}
            </>
          )
        }}
      </FormDataConsumer>
    </>
  )
}

export default EventServiceSection
